var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgKeys = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Keys")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/filled/keys",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8333333,30.3333334 C18.3311367,30.3333334 21.1666667,27.4978034 21.1666667,24 C21.1666667,20.5021966 18.3311367,17.6666667 14.8333333,17.6666667 C11.3355299,17.6666667 8.49999996,20.5021966 8.49999996,24 C8.49999996,27.4978034 11.3355299,30.3333334 14.8333333,30.3333334 Z",
    id: "Path",
    fill: "#D8F1EC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1666667,25 L23.1072833,25 C22.6132611,29.1308933 19.0972822,32.3333334 14.8333333,32.3333334 C10.2309604,32.3333334 6.49999996,28.6023729 6.49999996,24 C6.49999996,19.3976271 10.2309604,15.6666666 14.8333333,15.6666666 C19.0972822,15.6666666 22.6132611,18.8691067 23.1072833,23 L40.5,23 C41.0522848,23 41.5,23.4477153 41.5,24 L41.5,31.3333333 C41.5,31.8856181 41.0522848,32.3333333 40.5,32.3333333 C39.9477153,32.3333333 39.5,31.8856181 39.5,31.3333333 L39.5,25 L34.1666667,25 L34.1666667,29.5 C34.1666667,30.0522848 33.7189514,30.5 33.1666667,30.5 C32.6143819,30.5 32.1666667,30.0522848 32.1666667,29.5 L32.1666667,25 Z M14.8333333,30.3333334 C18.3311367,30.3333334 21.1666667,27.4978034 21.1666667,24 C21.1666667,20.5021966 18.3311367,17.6666666 14.8333333,17.6666666 C11.3355299,17.6666666 8.49999996,20.5021966 8.49999996,24 C8.49999996,27.4978034 11.3355299,30.3333334 14.8333333,30.3333334 Z",
    id: "Shape",
    fill: "#0A1428",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeys, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keys.18c736b7.svg";
export { ForwardRef as ReactComponent };